import { useState, useEffect, createContext } from 'react';
import {
    Box
} from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage'
import Toolbar from './Toolbar'

function App() {
    return (
        <Router>
            <Box sx={{ flexGrow: 1 }} style={{backgroundColor: 'white'}}>
                <Toolbar />
                <Routes>
                    <Route path="/tournament/:id_tournament" element={<HomePage />} />
                </Routes>
            </Box>
        </Router>
    );
}

export default App;
